import * as React from "react";
export default class IsLoading extends React.Component {

    render() {
        return (
                <div className={ "loading" }>
                    <div className={ "donut" } aria-hidden={ true } />
                </div>
        )
    }
}
